import { type ReactNode } from 'react'
import {
  ScreenHeaderContent,
  ScreenHeaderTitle,
} from '@/components/ScreenHeader'

export interface AccountSubviewScreenHeaderContentProps {
  kicker: ReactNode
  title: ReactNode
}

/**
 * Screen header content format common for account subviews.
 */
export function AccountSubviewScreenHeaderContent({
  kicker,
  title,
}: AccountSubviewScreenHeaderContentProps) {
  return (
    <ScreenHeaderContent>
      <header className="px-3xl mx-auto max-w-content">
        <ScreenHeaderTitle>
          <div className="text-body-lg mb-sm">{kicker}</div>
          <h1 className="text-display-lg">{title}</h1>
        </ScreenHeaderTitle>
      </header>
    </ScreenHeaderContent>
  )
}
